<template>
  <div id="Themestore_golf">
    <!-- 메인 배너 -->
    <div class="golf_mainwrap">
      <div class="golf_title">
        <img src="@/assets/img/themestore_golf/golf_title.png" alt="골프 타이틀" />
      </div>
    </div>
    <!-- 서브 타이틀 -->
    <div class="golf_sub_title1">
      <img src="../assets/img/themestore_golf/golf_sub_title1.jpg" alt="">
      <h3 class="golf_sub_font">일본에서 가장 아름다운 골프장부터  JPGA의 개막전이 열리는 골프장까지
      <br>일본 여행 전문 <span style="color: #a0ce52;">엔타비글로벌</span>이 추천하는 골프장!</h3>

      <h3 class="golf_sub_font2">일본에서 가장 아름다운 골프장부터<br>JPGA의 개막전이 열리는 골프장까지
      <br>일본 여행 전문 <span style="color: #a0ce52;">엔타비글로벌</span>이 추천하는 골프장!</h3>
    </div>

    <!-- Slick 캐러셀 -->
    <div class="spacial_carousel">
      <div class="autoplay">
        <div
          class="spacial_carousel_item"
          v-for="(item, index) in items"
          :key="index"
          @click="goToDetail(item.productId, item.salesRoute)"
        >
          <img :src="item.img" alt="골프 이미지" />
        </div>
      </div>

      <button class="prev-btn" @click="prevSlide"></button>
      <button class="next-btn" @click="nextSlide"></button>
    </div>

    <!-- BEST 상품 섹션 -->
    <div class="golf_sub_title1">
      <img src="@/assets/img/themestore_golf/golf_sub_title2.jpg" alt="">
      <h3 class="golf_sub_font">
        항공 숙박 라운딩까지 3박자를 고루 갖춘 <span style="color:#a0ce52;">BEST 상품</span>
      </h3>
      <h3 class="golf_sub_font2">
        항공 숙박 라운딩까지<br>3박자를 고루 갖춘 <span style="color:#a0ce52;">BEST 상품</span>
      </h3>
    </div>

    <div class="golf_besttour">
      <div
        class="golf_tourbox"
        v-for="tour in bestTours"
        :key="tour.id"
        @click="goToDetail(tour.id, 'T')"
      >
        <div :class="['golf_in_tour', tour.imgClass]"></div>
        <p class="golf_color_font">[인천출발항공]</p>
        <h4 class="golf_font_title">{{ tour.title }}</h4>
        <p class="golf_small_font">{{ tour.desc }}</p>
        <p class="golf_pay"><span class="pay_font">{{ tour.price }}</span>원</p>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import 'slick-carousel'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default {
  name: 'ThemestoreGolf',

  data() {
    return {
      $slider: null,
      items: [
        { img: require('@/assets/img/themestore_golf/golf_cos1.png'), productId: 'T-25102375BQC', salesRoute: 'T' },
        { img: require('@/assets/img/themestore_golf/golf_cos2.png'), productId: 'T-25102463AQC', salesRoute: 'T' },
        { img: require('@/assets/img/themestore_golf/golf_cos3.png'), productId: 'T-25102303BBC', salesRoute: 'T' },
        { img: require('@/assets/img/themestore_golf/golf_cos4.png'), productId: 'T-2025425-1745549287045', salesRoute: 'T' },
      ],
      bestTours: [
        { id: 'T-25102303BBC', imgClass: 'golf_tour_img1', title: '[나고야 45H] 도겐다도 온천골프 리조트 2박3일', desc: 'JPGA 개막전 개최지 도겐 홈메이트 컵 개최 골프장', price: '1,635,000' },
        { id: 'T-2025425-1745549287045', imgClass: 'golf_tour_img2', title: '[히로시마 45H] 세토우치 골프 리조트 3일', desc: '세토 내해가 한눈에 펼쳐지는 명품 코스', price: '1,379,000' },
        { id: 'T-25102375BQC', imgClass: 'golf_tour_img3', title: '[나리타 조석패턴 54H] 인터내셔널 리조트 & 온천', desc: '나리타 공항 인근 인기 힐링 골프 코스', price: '1,749,000' },
        { id: 'T-25102463AQC', imgClass: 'golf_tour_img4', title: '[시즈오카 54H] 테토라리조트 골프 3색 3일', desc: '온화한 날씨로 연중 라운딩 가능 명소', price: '1,090,000' },
      ],
    }
  },

  mounted() {
    this.$nextTick(() => {
      // slick 초기화
      this.initSlick()

      // 렌더 후 약간의 지연을 두고 클래스 추가 → 애니메이션 트리거
      const mainImg = document.querySelector('.golf_main_design')
      if (mainImg) {
        setTimeout(() => mainImg.classList.add('entered'), 50)
      }
    })
  },

  beforeUnmount() {
    if (this.$slider && this.$slider.hasClass('slick-initialized')) {
      this.$slider.slick('unslick')
    }
  },

  methods: {
    initSlick() {
      const slider = $('.autoplay')
      if (slider.hasClass('slick-initialized')) slider.slick('unslick')

      const isMobile = window.innerWidth <= 1024
      slider.slick({
        slidesToShow: isMobile ? 1 : 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: true,
        infinite: true,
        centerMode: isMobile,
        centerPadding: isMobile ? '10%' : '0',
      })

      this.$slider = slider
    },

    nextSlide() {
      if (this.$slider) this.$slider.slick('slickNext')
    },

    prevSlide() {
      if (this.$slider) this.$slider.slick('slickPrev')
    },

    goToDetail(productId, salesRoute) {
      this.$router.push({
        path: "/detail",
        query: { productId, salesRoute },
      });
    },
  },
}
</script>


<style scoped>
@import url('https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Regular.woff');


#Themestore_golf { margin-top: -56px;
}

.golf_mainwrap {
  margin: 0 auto 100px auto;
  max-width: 2000px;
  background-color: black;
  height: 800px;
  background: url(../assets/img/themestore_golf/golf_bg.jpg) center no-repeat;
}

.golf_main_design {
  position: absolute;
  z-index: 3;
  width: 25vw;
  max-width: 600px;
  min-width: 300px;
  top: 200px;
  left: 64%;
  transform: translateX(88%);
  transition: transform 1.5s ease;
}

.golf_main_design.entered {
  transform: translateX(-30%);
}

@media(max-width: 1920px){
  .golf_main_design.entered {
    transform: translateX(-18%);
  }
}

.golf_title {
  position: absolute;
  z-index: 2;
  width: 700px;
  height: 500px;
  top: 250px;
  left: 50%;
  transform: translateX(-50%);
}
.golf_title img{
  width: 100%;
}

.golf_sub_title1{
  text-align: center;
  margin: 200px auto 30px auto;
  max-width: 2000px;
}
.golf_sub_font{
  font-weight: bold;
  margin-bottom: 50px;
}
.golf_sub_font2{
  display: none;
  font-weight: bold;
  margin-bottom: 50px;
}

.spacial_carousel {
  position: relative;
  margin: 0 auto 100px auto;
  max-width: 1200px;
}

.autoplay .slick-slide {
  padding: 0 15px;
  box-sizing: border-box;
  pointer-events: none;
}

.spacial_carousel_item {
  pointer-events: auto;
  cursor: pointer;
  padding: 0 5%;
}

.spacial_carousel_item img {
  width: 100%;
  height: 500px;
  object-fit: cover;
  border-radius: 20px;
}

.prev-btn, .next-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  border: solid #d6d6d6 0.5px;
  cursor: pointer;
  z-index: 10;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.prev-btn{
  left: -70px;
  background: url(../assets/img/themestore_golf/left.jpg) no-repeat center;
  background-size: 70%;
}

.next-btn{
  right: -70px;
  background: url(../assets/img/themestore_golf/right.jpg) no-repeat center;
  background-size: 70%;
}

.slick-dots {
  bottom: -30px;
}

.slick-dots li button:before {
  font-size: 30px;
  color: #c7c7c7;
  opacity: 1;
}

.slick-dots li.slick-active button:before {
  color: #333;
}


.golf_besttour{
  margin: 0 auto 100px auto;
  height: 550px;
  max-width: 1600px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  font-family: Pretendard !important;
}

.golf_tourbox{
  width: 22%;
  height: auto;
  cursor: pointer;
}

.golf_in_tour{
  border-radius: 15px;
  width: 100%;
  height: 350px;
}

.golf_tour_img1{
  background: url(../assets/img/themestore_golf/doken.jpg) no-repeat center;
  background-size: 135%;
}

.golf_tour_img2{
  background: url(../assets/img/themestore_golf/setou.jpg) no-repeat center;
  background-size: 160%;
}

.golf_tour_img3{
  background: url(../assets/img/themestore_golf/oku.jpg) no-repeat center;
  background-size: 160%;
}

.golf_tour_img4{
  background: url(../assets/img/themestore_golf/fuji.jpg) no-repeat center;
  background-size: 175%;
}

.golf_color_font{
  color:#a0ce52;
  font-weight: bold;
  font-size: 16px;
  margin-top: 10px;
}

.golf_font_title{
  font-weight: bold;
  margin-top: -10px;
   white-space: wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 60px;
}

.golf_small_font{
  font-size: 16px;
  color: #9c9c9c;
  height: 50px;
}

.pay_font{
  font-size: 36px;
  font-weight: bold;
  color: #000;
}

.golf_pay{
  margin-top: -10px;
  font-size: 19px;
  font-weight: bold;
}


@media (max-width: 1024px) {
  .golf_mainwrap {
    height: 600px;
    background-size: cover;
    background-position: center;
    position: relative;
    overflow: hidden;
  }

  .golf_main_design {
    width: 45vw;
    top: 140px;
    left: 65%;
    transform: translateX(80%);
    z-index: 1;
  }

  .golf_main_design.entered {
    transform: translateX(-25%);
  }

  .golf_title { 
    width: 90%;
    top: 220px;
    left: 50%;
    transform: translateX(-50%);
  }
  .golf_title img {
    width: 100%; height: auto;
  }
  .golf_sub_title1{
     margin-top: 100px; 
  }
  .golf_sub_title1 img {
    width: 100%; height: auto;
  }

  .spacial_carousel {
    max-width: 100%;
  }
  .autoplay .slick-slide {
    padding: 0 5px;
  }
  .spacial_carousel_item img {
    width: 100%;
    height: 420px;
    object-fit: cover;
    border-radius: 15px;
  }

  .prev-btn, .next-btn {
    display: none !important;
  }


   .golf_besttour {
    display: flex;
    flex-wrap: wrap;         
    justify-content: space-between;
    gap: 20px;
    max-width: 93%;
    margin: 0 auto 80px auto;
    height: auto;
  }

  .golf_tourbox {
    width: calc(50% - 10px);
    margin-bottom: 20px;
    text-align: left; 
  }

  .golf_in_tour {
    height: 260px;
    border-radius: 15px;
    background-size: cover !important;
    background-position: center !important;
  }

  .golf_color_font,
  .golf_font_title,
  .golf_small_font,
  .golf_pay {
    text-align: left;
  }

  .golf_color_font {
    font-size: 14px;
    margin-bottom: 0px;
  }
  .golf_font_title {
    font-size: 18px;
    margin-top: 2px;
    margin-bottom: 2px;
    text-overflow: ellipsis;
    width: 100%;
    white-space: wrap;
    overflow: hidden;
    height: 45px;
  }
  .golf_small_font {
    font-size: 14px;
    color: #777;
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 20px;
    overflow: hidden;
  }
  .pay_font { 
    font-size: 26px;
  }

  .golf_pay {
    font-size: 16px;
  }

  .golf_sub_font{
    display: none;
  }

 .golf_sub_font2{
  display: block;
  margin: 0 auto;
  max-width: 400px;
  font-size: 18px;
  margin-bottom: 10px;
  padding: 0px 10px;
  }
}
</style>
